
import { ChevronDownIcon } from "vue-feather-icons";
import { NavigationLinks } from "../../../fc/Constants/config-navigation";
import { truncateEnd } from "~/fc/helpers";

export default {
    name: "NavigationLinks",
    components: {
        ChevronDownIcon
    },
    data: () => ({
        dropDownKey: 0,
    }),
    computed: {
        NavigationLinks() {
            return NavigationLinks(this);
        },
        dashboard() {
            return this.$route.fullPath.includes("/account");
        },
        isTab() {
            return this.$store.state.store.isTab;
        },
        activeMenu() {
            return this.$store.state.activeMenu;
        },
    },
    methods: {
        truncate(str, lim) {
            return truncateEnd(str, lim);
        },
        linkClick() {
            this.dropDownKey++;
        },
        setActiveMenu(menuName = "") {
            this.$store.commit("setActiveMenu", menuName);
        },
    },
};
